module.exports = "/static/assets/01fe593f7d8bda9fedbe0e1eaee47740.png";